var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 14.625H3.375C3.07663 14.625 2.79048 14.5065 2.5795 14.2955C2.36853 14.0845 2.25 13.7984 2.25 13.5V5.625C2.25 5.32663 2.36853 5.04048 2.5795 4.82951C2.79048 4.61853 3.07663 4.5 3.375 4.5H5.62459L6.74959 2.8125H11.2496L12.3746 4.5H14.625C14.9234 4.5 15.2095 4.61853 15.4205 4.82951C15.6315 5.04048 15.75 5.32663 15.75 5.625V13.5C15.75 13.7984 15.6315 14.0845 15.4205 14.2955C15.2095 14.5065 14.9234 14.625 14.625 14.625Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.8125C10.398 11.8125 11.5312 10.6792 11.5312 9.28125C11.5312 7.88328 10.398 6.75 9 6.75C7.60203 6.75 6.46875 7.88328 6.46875 9.28125C6.46875 10.6792 7.60203 11.8125 9 11.8125Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7cd90fa8ef681ceccf491323ba50170f.svg";
export { ForwardRef as ReactComponent };